module.exports = __webpack_public_path__ + "img/Stethoscope.1eddd654.png";